import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BASE_URL } from '@/config';
import Logo from '@/components/Logo';
import NavSection from './NavSection';
import { sidebarConfig } from './sidebarConfig';

const DRAWER_WIDTH = 264;

interface DashboardSidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function DashboardSidebar({ isOpen, onClose }: DashboardSidebarProps) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (isOpen) onClose();
  }, [pathname, isOpen, onClose]);

  const sidebarContent = (
    <div className="flex h-full flex-col">
      <div className="flex h-16 shrink-0 items-center border-b border-white/10 px-5">
        <Link to={BASE_URL} className="inline-flex">
          <Logo variant="light" className="text-lg" />
        </Link>
      </div>
      <nav className="flex-1 overflow-y-auto px-3 py-4">
        <NavSection navConfig={sidebarConfig} />
      </nav>
    </div>
  );

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-40 bg-slate-900/50 backdrop-blur-sm lg:hidden"
          onClick={onClose}
          aria-hidden
        />
      )}

      {/* Mobile */}
      <aside
        className={`fixed left-0 top-0 z-50 h-full transform bg-slate-900 shadow-xl transition-transform duration-200 ease-out lg:hidden ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
        style={{ width: DRAWER_WIDTH }}
      >
        {sidebarContent}
      </aside>

      {/* Desktop */}
      <aside
        className="hidden shrink-0 bg-slate-900 lg:block"
        style={{ width: DRAWER_WIDTH }}
      >
        <div
          className="fixed left-0 top-0 flex h-full flex-col"
          style={{ width: DRAWER_WIDTH }}
        >
          {sidebarContent}
        </div>
      </aside>
    </>
  );
}
